import flow from "../assets/flow.json";
var LocalStorageService = /** @class */ (function () {
    function LocalStorageService(storageKey) {
        this.storageKey = storageKey;
        this._ls = { email: "", token: "", userId: "", userName: "" };
        this._lsLogin = {
            token: "",
            clientId: "",
            countryId: "",
            branchId: "",
            userId: "",
            roles: [],
            email: "",
            userName: "",
            idToken: {
                jwtToken: "",
                payload: {
                    name: "",
                    family_name: "",
                },
            },
        };
        this._mh = [];
        this._pageActionFlags = [];
        this._variables = [];
        this._mhSide = [];
        var steps = [];
        var index = 0;
        flow.data.flowStep.steps.forEach(function (step) {
            var tempStep = {
                step: index,
                id: "",
                name: index.toString(),
                completed: false,
                route: step.route,
                icon: step.icon,
                email: "",
                campaign: "",
                campaignSelected: "",
                paymentMode: "",
                paymentModeSelected: "",
                coverType: "",
                quoteId: "",
                policyId: "",
                vehiclesDetails: "",
                auditDocumentUrl: "",
                financialInformation: "",
                initialInfo: "",
                applicantDeclaration: "",
                medicalInformation: "",
            };
            index++;
            steps.push(tempStep);
        });
        this._lsStep = {
            steps: steps,
        };
    }
    LocalStorageService.prototype.getUserStored = function () {
        var storedData = localStorage.getItem(this.storageKey);
        if (storedData) {
            this._ls = JSON.parse(storedData);
            return this._ls;
        }
        return this._ls;
    };
    LocalStorageService.prototype.setUserStored = function (user) {
        var storedData = JSON.parse(user);
        localStorage.setItem(this.storageKey, JSON.stringify(storedData));
    };
    LocalStorageService.prototype.setLogout = function () {
        localStorage.removeItem(this.storageKey);
    };
    LocalStorageService.prototype.isAuthenticated = function () {
        return !!this.getUserStored().token;
    };
    LocalStorageService.prototype.getUserLoginStored = function () {
        var storedData = localStorage.getItem(this.storageKey);
        if (storedData) {
            this._lsLogin = JSON.parse(storedData);
            return this._lsLogin;
        }
        return this._lsLogin;
    };
    LocalStorageService.prototype.setUserLoginStored = function (userLogin) {
        localStorage.setItem(this.storageKey, JSON.stringify(userLogin));
    };
    /*Steps*/
    LocalStorageService.prototype.getStepStored = function () {
        var storedData = localStorage.getItem(this.storageKey);
        if (storedData) {
            this._lsStep = JSON.parse(storedData);
            return this._lsStep;
        }
        return this._lsStep;
    };
    LocalStorageService.prototype.setStepStored = function (step) {
        var steps = this.getStepStored();
        var foundStep = steps.steps.find(function (e) { return e.step === step.step; });
        if (foundStep)
            foundStep.id = step.id;
        foundStep.name = step.name;
        foundStep.completed = step.completed;
        foundStep.campaign = step.campaign;
        foundStep.coverType = step.coverType;
        foundStep.campaignSelected = step.campaignSelected;
        foundStep.paymentMode = step.paymentMode;
        foundStep.paymentModeSelected = step.paymentModeSelected;
        foundStep.quoteId = step.quoteId;
        foundStep.policyId = step.policyId;
        foundStep.email = step.email;
        foundStep.route = step.route;
        foundStep.icon = step.icon;
        foundStep.flow = step.flow;
        foundStep.vehiclesDetails = step.vehiclesDetails;
        foundStep.auditDocumentUrl = step.auditDocumentUrl;
        foundStep.initialInfo = step.initialInfo;
        foundStep.applicantDeclaration = step.applicantDeclaration;
        foundStep.financialInformation = step.financialInformation;
        foundStep.medicalInfo = step.medicalInfo;
        foundStep.applicantInformation = step.applicantInformation;
        //const storedData = JSON.parse(steps);
        // localStorage.setItem(this.storageKey, JSON.stringify(steps));
    };
    /*END Steps*/
    /*Set Menu Options*/
    LocalStorageService.prototype.setMenuHorizontalStored = function (menuHorizontal) {
        localStorage.setItem(this.storageKey, JSON.stringify(menuHorizontal));
    };
    LocalStorageService.prototype.getMenuHorizontalStored = function () {
        var storedData = localStorage.getItem(this.storageKey);
        if (storedData) {
            this._mh = JSON.parse(storedData);
            return this._mh;
        }
        return this._mh;
    };
    /*End*/
    /*Set Page Action Flags*/
    LocalStorageService.prototype.setPageActionFlagsStored = function (pageActionFlags) {
        localStorage.setItem(this.storageKey, JSON.stringify(pageActionFlags));
    };
    LocalStorageService.prototype.getPageActionFlagsStored = function () {
        var storedData = localStorage.getItem(this.storageKey);
        if (storedData) {
            this._pageActionFlags = JSON.parse(storedData);
            return this._pageActionFlags;
        }
        return this._pageActionFlags;
    };
    LocalStorageService.prototype.setVariablesStored = function (variables) {
        console.log("variables", variables);
        console.log(this.storageKey);
        console.log(JSON.stringify(variables));
        localStorage.setItem(this.storageKey, JSON.stringify(variables));
    };
    LocalStorageService.prototype.getVariablesStored = function () {
        var storedData = localStorage.getItem(this.storageKey);
        if (storedData) {
            this._variables = JSON.parse(storedData);
            return this._variables;
        }
        return this._variables;
    };
    /*Set Menu SideBar*/
    LocalStorageService.prototype.setMenuSideBarStored = function (menuSideBar) {
        localStorage.setItem(this.storageKey, JSON.stringify(menuSideBar));
    };
    LocalStorageService.prototype.getMenuSideBarStored = function () {
        var storedData = localStorage.getItem(this.storageKey);
        if (storedData) {
            this._mhSide = JSON.parse(storedData);
            return this._mhSide;
        }
        return this._mhSide;
    };
    return LocalStorageService;
}());
export default LocalStorageService;
